import { useEffect } from 'react';

const SeasonTitle = () => {
    useEffect(() => {
        document.title = "Seasons | DCGP";
    }, []);

    return null;
};

export default SeasonTitle;
